/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnersResponse
 */
export interface PartnersResponse {
    /**
     * Partner's id (matching the stingray.organization_partner table)
     * @type {string}
     * @memberof PartnersResponse
     */
    partnerId: string;
}

export function PartnersResponseFromJSON(json: any): PartnersResponse {
    return PartnersResponseFromJSONTyped(json, false);
}

export function PartnersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partnerId': json['partnerId'],
    };
}

export function PartnersResponseToJSON(value?: PartnersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partnerId': value.partnerId,
    };
}

